import React from 'react'

export default function Contact(props) {
  return (
    <div className='container text-red-500 m-auto'>Contact</div>
  )
}
